import { Outlet } from "react-router";
import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";

const ActivityOrgLayout = () => {
   const navList = useNav();
  let {activityOrgBottomNav, topActivityNav} = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={activityOrgBottomNav} topTabs={topActivityNav} />
      <Outlet />
    </div>
  )
}

export default ActivityOrgLayout;